<template>
    <div class="listmain ">
        <h1 class="firTitle">槽位</h1>
        <p>
          槽位:描述意图的数据(键值对的集合),也是实现意图所需要的参数
          识别并准确执行意图，往往需要获取一些必要参数，如查天气需要时间和地点两个参数。
          开发者可以通过编辑槽位列表，定义所需参数以及参数所需要的词典。
          如果开启多轮对话，那么可以通过槽位列表-值来引用前置意图中的参数
       </p>
      <h5 class="codeTitle">追问语句</h5>
      <p>
        用户打开必填项开关后，当槽位缺失情况下，会随机选择用户填写的追问语句发起追问
      </p>
      <p>
        场景：<br>
        Q:设置今天的闹钟（缺失时间槽位）<br>
        AI:请告诉我时间？ （发起追问）<br>
        Q：早上8点钟（填补槽位）<br>
        AI：好的，已帮您设置好闹钟<br>
      </p>
      <h5 class="codeTitle">槽位描述协议</h5>
      <p>
        <router-link to="/tutor/zdyjn_nlupro">
          <a href="#" class="se-2-a">查看NLU语义表示协议</a>
        </router-link>
      </p>


    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }



  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/zygn_cw.vue